module.exports = __webpack_public_path__ + "static/img/sticker-upto-30per-off.e53a3be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/sticker/sticker-upto-30per-off.png
// module id = Q+VQ
// module chunks = 134